import React, { memo } from 'react';
import { t } from 'ttag';

function Menu({ setIsMenuOpen }) {
  return (
    <button
      type="button"
      className="m-0 flex items-center border-0 bg-transparent p-3 outline-none focus:outline-none lg:hidden"
      aria-label={t`Open Navigation`}
      onClick={() => setIsMenuOpen(true)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-6 w-6 shrink-0"
      >
        <line x1="4" x2="20" y1="12" y2="12" />
        <line x1="4" x2="20" y1="6" y2="6" />
        <line x1="4" x2="20" y1="18" y2="18" />
      </svg>
    </button>
  );
}

export default memo(Menu);
